import { Component, Input } from '@angular/core';
import { DateTimeFormatPipe } from '../../pipes/date-time-format.pipe';
import { Order, OrderArrival } from '../../../../../overview/models/order';

type ArrivalKey = keyof OrderArrival;

@Component({
  selector: 'app-arrival',
  standalone: true,
  templateUrl: './arrival.component.html',
  imports: [DateTimeFormatPipe],
  styleUrl: './arrival.component.scss'
})
export class ArrivalComponent {
  @Input() set order(value: Order | null) {
    if (!value || !value.routing || !value.routing.destination) {
      return;
    }
    this.dates = Object.entries(value.routing.destination)
      .filter(([key, value]) => value && Object.hasOwn(this.dateLabels, key))
      .map(([key, val]) => ({ label: this.dateLabels[key as ArrivalKey], value: val as string }))
      .sort((a, b) => new Date(a.value).getTime() - new Date(b.value).getTime());
  }

  dates: { label: any; value: string }[] = [];
  readonly dateLabels: Record<ArrivalKey, string> = {
    originalEta: 'Original ETA',
    currentEta: 'Current ETA',
    requestedNewEta: 'Req. New ETA',
    bookedEta: 'Booked ETA',
    etaAtBookingDate: 'ETA Booking Date'
  };
}
